export const domainSubscription = 'https://podpiska.koleso.ru';

export const listRegionShowSubscription = [];
